module.exports = __webpack_public_path__ + "static/media/leaf.4b9cf920.svg";